import { render, staticRenderFns } from "./TowerCard.vue?vue&type=template&id=8b138a22&scoped=true&"
import script from "./TowerCard.vue?vue&type=script&lang=js&"
export * from "./TowerCard.vue?vue&type=script&lang=js&"
import style0 from "./TowerCard.vue?vue&type=style&index=0&id=8b138a22&lang=less&scoped=true&"
import style1 from "./TowerCard.vue?vue&type=style&index=1&id=8b138a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b138a22",
  null
  
)

export default component.exports